import Component from './component';

export interface Props {
	title: string;
	stages: string;
}

Component.defaultProps = {};

export default Component;
